import Flex from 'shopper/components/Flex';

import Image from '../Image';

import APP from 'constants/app';
import COMPARAI from 'constants/comparai';

const Heading = () => (
  <Flex bg={COMPARAI.COLOR} p={4} mb={4} full>
    <Image
      alt="Comparai"
      width={126}
      height={20}
      src={`${APP.LOCAL_IMAGE_PATH}/features/comparai/comparai-logo.svg`}
    />
  </Flex>
);

export default Heading;
